// Configurações da marca Concilia POS.
// Mantém o storagePrefix histórico (conciliaPOS) para preservar o padrão
// de chaves já usado pelo bundle atual.
//
// theme.light e theme.dark são os dois conjuntos completos de tokens
// consumidos por componentes via CSS custom properties (var(--token-*)).
// theme.primary/primaryDark/accent/gradient seguem expostos como shortcuts
// para callers legados — apontam para a paleta light por padrão.
const lightTheme = {
  primary: '#7D45DC',
  primaryDark: '#5B2EAE',
  primaryLight: '#A77BE5',
  accent: '#A77BE5',
  background: '#F8F8F8',
  surface: '#FFFFFF',
  surfaceAlt: '#F8F8F8',
  border: '#EBE9F1',
  divider: '#EBE9F1',
  text: {
    primary: '#5E5873',
    secondary: '#6E6B7B',
    hint: '#94A3B8',
    onPrimary: '#FFFFFF',
    onSurface: '#5E5873'
  },
  status: {
    success: '#28C76F',
    error: '#EA5455',
    warning: '#FF9F43',
    info: '#00CFE8'
  },
  // Soft tints — fundos delicados (cards info, badges, hovers leves).
  // Mantem os hex Vuexy ja em uso na Concilia para zero regressao visual.
  soft: {
    primary: '#EEECFF',
    success: '#DDF6E8',
    error: '#FCE4E4',
    warning: '#FFF5EB',
    info: '#E0F8FB'
  },
  dataviz: ['#7D45DC', '#A77BE5', '#28C76F', '#FF9F43', '#00CFE8'],
  gradient: 'linear-gradient(118deg, #7D45DC, rgba(125, 69, 220, 0.7))'
}

const darkTheme = {
  primary: '#7D45DC',
  primaryDark: '#5B2EAE',
  primaryLight: '#A77BE5',
  accent: '#A77BE5',
  background: '#161D31',
  surface: '#283046',
  surfaceAlt: '#161D31',
  border: '#3B4253',
  divider: '#3B4253',
  text: {
    primary: '#D0D2D6',
    secondary: '#B4B7BD',
    hint: '#676D7D',
    onPrimary: '#FFFFFF',
    onSurface: '#D0D2D6'
  },
  status: {
    success: '#28C76F',
    error: '#EA5455',
    warning: '#FF9F43',
    info: '#00CFE8'
  },
  // Soft tints no dark — derivados ~12% alpha sobre surface escura,
  // resolvidos para hex equivalente para nao depender de color-mix em runtime.
  soft: {
    primary: '#1F1A3D',
    success: '#1A3328',
    error: '#3A2126',
    warning: '#3A2A1F',
    info: '#1A2E3A'
  },
  dataviz: ['#7D45DC', '#A77BE5', '#28C76F', '#FF9F43', '#00CFE8'],
  gradient: 'linear-gradient(118deg, #7D45DC, rgba(125, 69, 220, 0.7))'
}

const concilia = {
  key: 'concilia',
  isNexPOS: false,
  isConciliaPOS: true,
  appName: 'ConciliaPOS',
  displayName: 'ConciliaPOS',
  storagePrefix: 'conciliaPOS',
  apiUrls: {
    dev: 'https://api-hml-conciliapos.suportepos.com.br/',
    stag: 'https://api-conciliapos-stag.suportepos.com.br/',
    hml: 'https://api-hml-conciliapos.suportepos.com.br/',
    prod: 'https://api-conciliapos.suportepos.com.br/'
  },
  corporateUrl: 'https://suportepos.com.br/',
  institutional: 'A conciliaPOS é um produto da SuportePOS.',
  invoiceFilenamePrefix: 'boleto_conciliaPOS',
  excelFilenamePrefix: 'conciliaPOS',
  pageTitleSuffix: 'conciliaPOS',
  invoiceReturnUrl: 'https://suportepos.com.br/',
  theme: {
    primary: lightTheme.primary,
    primaryDark: lightTheme.primaryDark,
    accent: lightTheme.accent,
    gradient: lightTheme.gradient,
    // Cor exibida na address bar do navegador (PWA theme_color e
    // <meta name="theme-color">). Concilia usa o primary; NexPOS usa o
    // primaryDark - decisão CTO em SUP-81 / addendum SUP-46.
    metaThemeColor: lightTheme.primary,
    light: lightTheme,
    dark: darkTheme
  },
  assets: {
    logo: require('@src/assets/images/logo/concilia/logo.svg').default,
    logoDark: require('@src/assets/images/logo/concilia/logo_dark.svg').default,
    logoMonoLight: require('@src/assets/images/logo/concilia/logo_dark.svg').default,
    powerby: require('@src/assets/images/logo/logosuportepos.svg').default
  }
}

export default concilia
